import React from 'react';
import { useSelector } from 'react-redux';
import './scss/GreetingHeader.scss';

const GreetingHeader = () => {
    const { user } = useSelector((state) => state.user);
    const firstName = user?.user?.name?.split(' ')[0] || 'there';

    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour < 12) return { text: 'Good morning', emoji: '🌤️' };
        if (hour < 18) return { text: 'Good afternoon', emoji: '☀️' };
        return { text: 'Good evening', emoji: '🌙' };
    };

    const greeting = getGreeting();

    const formatDate = () => {
        const options = { weekday: 'long', month: 'long', day: 'numeric' };
        return new Date().toLocaleDateString('en-US', options);
    };

    return (
        <div className="zoobbe-greeting-header">
            <p className="current-date">{formatDate()}</p>

            <h1><span>{greeting.text}</span>, {firstName}! {greeting.emoji}</h1>
        </div>
    );
};

export default GreetingHeader;
